import req from "./request";

export default {
  index: async () => {
    try {
      const building = JSON.parse(localStorage.getItem("building")) || null;

      let url = `construction-diaries?building_id=${building.id}`;
      const { data } = await req.get(url, true);
      return data;
    } catch (error) {
      throw error;
    }
  },
  show: async (id) => {
    try {
      const building = JSON.parse(localStorage.getItem("building")) || null;

      const { data } = await req.get(
        `construction-diaries/${id}?building_id=${building.id}`,
        true
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
  store: async (data) => {
    try {
      const building = JSON.parse(localStorage.getItem("building")) || null;
      const response = await req.post(
        `construction-diaries?building_id=${building.id}`,
        data,
        true
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
  storeDocuments: async (data, constructionDiaryId) => {
    try {
      const building = JSON.parse(localStorage.getItem("building")) || null;
      let url = `construction-diaries/documents?building_id=${building.id}&construction_diary_id=${constructionDiaryId}`;
      return await req.post(url, data, true);
    } catch (error) {
      throw error;
    }
  },
  update: async (id, data) => {
    try {
      const building = JSON.parse(localStorage.getItem("building")) || null;
      let url = `construction-diaries/${id}?building_id=${building.id}`;

      const response = await req.put(url, data, true);
      return response;
    } catch (error) {
      throw error;
    }
  },
  destroy: async (id) => {
    try {
      const building = JSON.parse(localStorage.getItem("building")) || null;
      let url = `construction-diaries/${id}?building_id=${building.id}`;

      const response = await req.delete(url, true);
      return response;
    } catch (error) {
      throw error;
    }
  },
  download: async (id) => {
    try {
      const building = JSON.parse(localStorage.getItem("building")) || null;
      let url = `construction-diaries/documents/${id}/download?building_id=${building.id}`;
      return await req.get(url, true);
    } catch (error) {
      throw error;
    }
  },
  downloadSingle: async (id, constructionDiaryId) => {
    try {
      const building = JSON.parse(localStorage.getItem("building")) || null;
      let url = `construction-diaries/documents/${id}/download-single?building_id=${building.id}?construction_diary_id=${constructionDiaryId}`;

      return await req.get(url, true);
    } catch (error) {
      throw error;
    }
  },
};
